class VideoPlayer {
    constructor() {
        this.playBtn = document.getElementById('play-btn')
        this.videoPoster = document.getElementById('video-poster')
        this.videoIframe = document.getElementById('video-iframe')
        this.videoContainer = document.querySelector('.video-container')
        
        if (this.playBtn && this.videoPoster && this.videoIframe) {
            this.init()
        }
    }
    
    init() {
        this.playBtn.addEventListener('click', () => this.playVideo())
        //this.videoIframe.addEventListener('load', (e) => this.handleIframeLoad(e))
    }

    playVideo() {
        // Ocultar el poster y el botón
        this.videoPoster.style.display = 'none'
        this.playBtn.style.display = 'none'
        
        // Mostrar el iframe
        this.videoIframe.classList.remove('hidden')
        this.videoIframe.classList.remove('pointer-events-none')
        this.videoContainer.classList.remove('pointer-events-none')
        
        // Agregar autoplay al iframe
        const currentSrc = this.videoIframe.src
        this.videoIframe.src = currentSrc + '&autoplay=1'
    }

    handleIframeLoad(e) {
        console.log(e)
        // Asegurarse de que el botón y el poster estén ocultos cuando el iframe se carga
        this.videoPoster.style.display = 'none'
        this.playBtn.style.display = 'none'
        this.videoContainer.classList.remove('pointer-events-none')
    }
}

export default VideoPlayer 